module.exports = __webpack_public_path__ + "2147908b1209c8588729d0b1295747c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/goldencity21.jpg
// module id = 900
// module chunks = 0